export default __webpack_public_path__ + "static/media/sigma-details.dcac3fea.PNG";